<template lang="pug">

    #variant-menu.ui.secondary.pointing.menu

        //- Varianten
        a.item(
            v-for='variant in value'
            v-bind:class='{ active: variant.number === activeVariantNumber }'
            v-on:click="change(variant.number)"
        ) Variante {{ variant.number }}

        //- Actions
        .right.menu

            //- Variante entfernene
            a.item(v-on:click="remove()" v-show='value.length > 1')
                i.remove.icon
                | Variante entfernen

            //- Variante hinzufuegen
            a.item(v-on:click="copy()" v-show='value.length < 5')
                i.add.icon
                | Variante hinzufügen

</template>

<script>

    //noinspection JSUnusedGlobalSymbols
    export default {

        methods: {
            change(number) {
                this.$emit('change', number)
            },
            copy() {
                // Varianten kopieren
                const variants = [ ...this.value ]

                // Aktive Variante suchen
                const active   = variants.find(variant => variant.number === this.activeVariantNumber)

                // Aktive Variante kopieren
                const variant  = { ...active }

                // Varianten-Nummer erhoehen
                variant.number = variants.length + 1

                // Varianten hinzufuegen
                variants.push(variant)
                this.$emit('input', variants)
                this.$emit('change', variants.length)
            },
            remove() {
                const variants = this.value
                    // Selektierte Variante entfernen
                    .filter(variant => variant.number !== this.activeVariantNumber)

                    // Variantennummern neu setzen
                    .map((variant, index) => {
                        const copy = { ...variant }
                        copy.number = index + 1
                        return copy
                    })

                this.$emit('input', variants)
                this.$emit('change', variants.length)
            }
        },

        props: {
            activeVariantNumber: {
                type: Number,
                required: true
            },
            value: {
                type: Array,
                required: true
            }
        }

    }

</script>

<!--suppress CssUnusedSymbol -->
<style>

    #variant-menu {
        margin-top: 0;
    }

</style>
